import { render } from "./CourseItems.vue?vue&type=template&id=256f9e16"
import script from "./CourseItems.vue?vue&type=script&lang=js"
export * from "./CourseItems.vue?vue&type=script&lang=js"

import "./CourseItems.vue?vue&type=style&index=0&id=256f9e16&lang=scss"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__